<template>
  <material-card
    :title="$t('components.chequerequisitionform.title_{0}', [option.InsuranceCarrierName])"
    icon="payment"
    :color="$vuetify.theme.themes.light.secondary"
  >
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" xs="12" v-if="option.DateOfRequest != null">
            <pbas-date-picker
              :value="option.DateOfRequest"
              @update-date="option.DateChequeRequired=$event"
              :label="$t('components.chequerequisitionform.date_of_request')"
              required
            ></pbas-date-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <pbas-date-picker
              :value="option.DateChequeRequired"
              @update-date="option.DateChequeRequired=$event"
              :label="$t('components.chequerequisitionform.date_chequepayment_required')"
              required
            ></pbas-date-picker>
          </v-col>
          <v-col cols="auto" class="justify-content-center">
            <v-layout>
              <v-flex class="align-self-center">
                <v-menu
                  ref="menu"
                  v-model="timePicker"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="time"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <no-autocomplete-textfield
                      v-model="time"
                      :label="$t('components.chequerequisitionform.time')"
                      prepend-icon="access_time"
                      readonly
                      v-on="on"
                    ></no-autocomplete-textfield>
                  </template>
                  <v-time-picker
                    v-if="timePicker"
                    v-model="time"
                    full-width
                    @click:minute="$refs.menu.save(time)"
                    format="24hr"
                    time-picker-title-btn-height="28px"
                  ></v-time-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <no-autocomplete-textfield
              :disabled="true"
              :label="$t('components.chequerequisitionform.payee')"
              v-model="option.InsuranceCarrierName"
            ></no-autocomplete-textfield>
            <!-- <trans-textarea
              v-model="option.AdditionalNotes"
              :label="$t('components.chequerequisitionform.additional_notes')"
              field="Name"
              :dialog="dialog"
            ></trans-textarea> -->
            <v-textarea
              v-model="option.AdditionalNotes"
              :label="$t('components.chequerequisitionform.additional_notes')"
            ></v-textarea>
            <v-checkbox
              :label="$t('components.chequerequisitionform.signatures')"
              v-model="option.SignaturesRequired"
            ></v-checkbox>
            <no-autocomplete-textfield
              :label="$t('components.chequerequisitionform.signatures_expected')"
              v-if="option.SignaturesRequired"
              v-model="option.SignatureList"
            ></no-autocomplete-textfield>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn color text @click="cancel">{{$t('globals.close')}}</v-btn>
      <v-btn color="primary" text @click="save">{{$t('globals.save')}}</v-btn>
    </v-card-actions>
  </material-card>
</template>

<script>
import TransTextarea from "../components/TransTextarea";
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import { translate2 } from '../trans2'
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
export default {
  name: "cheque-requisition-form",
  props: ["option", "dialog"],
  components: {TransTextarea, NoAutocompleteTextfield},
  data() {
    return {
      timePicker: false,
      time: null
    };
  },
  computed: {
    ...mapGetters("common", ["messages"])
  },
  watch: {
    dialog() {
      if (this.dialog) this.time = "00:00";
      else  this.time = null;
    },
    time() {
      if (!this.time) return;

      this.option.DateChequeRequiredHour = this.time.split(":")[0];
      this.option.DateChequeRequiredMinutes = this.time.split(":")[1];
    },
    // option() {
    //   if (this.option.AdditionalNotes === undefined) this.option.AdditionalNotes = {};
    // }
  },
  mounted() {
    this.time = "00:00";
    console.log(this.option)
  },
  methods: {
    trans(item, field) {
      //console.log(item)
      return translate2(item, field)
    },
    save() {
      this.$emit("save");
    },
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>
<style>
  .v-picker__title__btn {
    font-size: 36px!important;
    height: 36px!important;
  }
  .v-time-picker-title__time span {
    font-size: 36px!important;
    height: 36px!important;
  }
</style>